module.exports = __webpack_public_path__ + "app/img/Airbag3D_francais.c1991e4d.jpg";